import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { compactNaira } from "../../lib/format";
import { Landmark, CreditCard, ArrowRightLeft, Wallet } from "lucide-react";
import { C } from "./AccountingLayout";

const ACCOUNTS = [
  { code: "1010", label: "Cash Till", Icon: Wallet, color: C.green, tint: C.greenTint },
  { code: "1020", label: "Bank Account", Icon: Landmark, color: "#1E5FBF", tint: "#E7F1FE" },
  { code: "1050", label: "Card Receivable", Icon: CreditCard, color: "#6E28A6", tint: "#F2E7FD" },
  { code: "1060", label: "Transfer Receivable", Icon: ArrowRightLeft, color: "#B4570A", tint: "#FEF0DA" },
];

export default function BankCash() {
  const [tb, setTb] = useState(null);
  const [cf, setCf] = useState(null);
  useEffect(() => {
    api.get("/reports/trial-balance").then(setTb).catch(() => {});
    api.get("/reports/cash-flow").then(setCf).catch(() => {});
  }, []);

  const balOf = (code) => {
    const r = (tb?.rows || []).find((x) => x.code === code);
    return r ? r.debit - r.credit : 0;
  };
  const total = ACCOUNTS.reduce((s, a) => s + balOf(a.code), 0);

  return (
    <div className="space-y-4" data-testid="bank-cash-page">
      <div className="rounded-xl bg-white border p-5" style={{ borderColor: C.border }}>
        <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: C.muted }}>Total Cash Position</div>
        <div className="font-brand font-bold text-4xl mt-1" style={{ color: C.burgundy }}>{compactNaira(total)}</div>
        {cf && <div className="text-[12px] mt-1" style={{ color: C.softMuted }}>This month: <span style={{ color: C.green }}>+{compactNaira(cf.inflow)}</span> / <span style={{ color: C.red }}>-{compactNaira(cf.outflow)}</span> = <span style={{ color: cf.net >= 0 ? C.green : C.red, fontWeight: 600 }}>{compactNaira(cf.net)}</span></div>}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {ACCOUNTS.map((a) => (
          <div key={a.code} className="rounded-xl bg-white border p-5" style={{ borderColor: C.border }} data-testid={`cash-${a.code}`}>
            <div className="w-11 h-11 rounded-full flex items-center justify-center" style={{ background: a.tint, color: a.color }}><a.Icon size={20} /></div>
            <div className="text-[11px] font-semibold mt-3" style={{ color: C.muted }}>{a.label}</div>
            <div className="font-brand font-bold text-2xl mt-1" style={{ color: C.text }}>{compactNaira(balOf(a.code))}</div>
            <div className="text-[10px] font-mono mt-1" style={{ color: C.softMuted }}>{a.code}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
